<template>
    <van-popup v-model:show="show" position="bottom" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: 'transparent'
    }">
        <div class="name_pop">
            <van-row class="title">
                <van-col span="22" style="display: flex; justify-content: center; align-items: center;">
                    {{ $t('profile.withdrawalPassword') }}
                </van-col>
                <van-col span="2">
                    <img src="@/assets/profile/cs_close.png" alt="" @click="close">
                </van-col>
            </van-row>

            <div class="content">
                <InputField v-if="userStore.withdrawPassword" v-model="oldPassword"
                    :labelText="$t('profile.enterOldPassword')" :isPassword="true" @valueChanged="oldPasswordChange" />

                <InputField v-model="password" :labelText="$t('profile.enterNewPassword')" :isPassword="true"
                    @valueChanged="passwordChange" />
                <div v-if="passwordValidationNotice" class="errorNotice">
                    {{ $t('loginRegister.passwordForamt') }}
                </div>
                <InputField v-model="confirmPassword" :labelText="$t('profile.cnofirmNewPassword')"
                    @valueChanged="confirmPasswordChange" :isPassword="true" />
                <div v-if="confirmPassword && password && confirmPassword !== password" class="errorNotice">
                    {{ $t('loginRegister.differentPassword') }}
                </div>

                <div class="btn_container">
                    <MainButton :title="$t('profile.save')" :activeStatus="isSubmitBtnActivated"
                        @click="handleUpdatePassword" />
                </div>
            </div>
        </div>
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    </van-popup>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import InputField from './inputField.vue'
import { useUserStore } from '@/stores/user'
import StatusPopup from '@/components/common/statusPopup.vue'
import { checkConfirmPasswordValidation, checkWithdrawPasswordValidation, updateWithdrawPassword } from '@/view/profile/supportScript'
import MainButton from '../../components/common/mainButton.vue'
const userStore = useUserStore()
const id = computed(() => userStore.id)
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const password = ref('')
const oldPassword = ref('')
const confirmPassword = ref('')
const passwordValidationNotice = ref(false)
const confirmPasswordValidationNotice = ref(false)
const isSubmitBtnActivated = computed(() => {
    return (
        (userStore.withdrawPassword ? oldPassword.value.length > 0 : true) &&
        password.value.length > 0 &&
        confirmPassword.value.length > 0 &&
        !passwordValidationNotice.value &&
        !confirmPasswordValidationNotice.value &&
        password.value === confirmPassword.value
    );
})
const open = () => {
    show.value = true
}

const close = () => {
    show.value = false
    oldPassword.value = ''
    password.value = ''
    confirmPassword.value = ''
}
const oldPasswordChange = (value: string) => {
    oldPassword.value = value
}

const passwordChange = (value: string) => {
    password.value = value
    checkWithdrawPasswordValidation(value, passwordValidationNotice)
}

const confirmPasswordChange = (value: string) => {
    confirmPassword.value = value
    checkConfirmPasswordValidation(value, confirmPassword, password, confirmPasswordValidationNotice)
}

const handleUpdatePassword = () => {
    updateWithdrawPassword(oldPassword.value, password.value, show, toastContent, isSuccess, statusRef)
}
defineExpose({
    open,
})

</script>
<style scoped>
.van-popup {
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
    border-top-left-radius: 0rem !important;
    border-top-right-radius: 0rem !important;
    border: 1px solid rgba(255, 255, 255, 0.10) !important;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.25), inset 0 1px 0 0 rgba(255, 255, 255, .25) !important;
    backdrop-filter: blur(20px) !important;
    height: 100vh;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.title {
    padding: 10px 10px;
    font-size: 14px;
    background: #312734 !important;
    color: #ffa4d1;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.title img {
    width: 25px;
    padding-top: 5px;
    opacity: 0.6;
}

.van-overlay {
    background-color: #00000047
}


.content {
    padding: 30px 15px;
}


.label {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.45);
}

.errorNotice {
    color: #E00000;
    font-size: 15px;
    padding: 0 15px;
}

.btn_container {
    padding: 30px 90px;
}

.defaultButton {
    margin: 40px;
    display: flex;
    justify-content: center;
}

::v-deep(.custom-save-btn.van-button) {
    width: 50%;
    background-color: #ff69b4 !important;
    border-color: #ff69b4 !important;
    color: #fff !important;
    height: 50px;
    /* optional: adjust height */
    border-radius: 5px;
    /* optional: rounded edges */
}


::v-deep(.custom-save-btn.van-button--disabled) {
    background-color: #ff69b4 !important;
    border-color: #ffb6c1 !important;
    opacity: 0.7;
}
</style>